import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/cpcic-admin-release/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BasicLayout from '@/layouts/basic-layout';
var meta = {
  auth: true
};
var pre = 'statistics-';
export default {
  path: '/statistics',
  name: 'statistics',
  redirect: {
    name: "".concat(pre, "resource-visit")
  },
  meta: meta,
  component: BasicLayout,
  children: [{
    path: 'resource-visit',
    name: "".concat(pre, "resource-visit"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '资源访问',
      closable: false
    }),
    component: function component() {
      return import('@/pages/statistics/resource-visit');
    }
  }, {
    path: 'vote',
    name: "".concat(pre, "vote"),
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      title: '投票',
      closable: false
    }),
    component: function component() {
      return import('@/pages/statistics/vote');
    }
  }]
};